import React, { useState } from 'react'
import DetailLog from 'tennders-transactions/views/log/DetailLog'
import DetailDocuments from 'tennders-documents/views/DetailDocuments'
import useTranslation from 'next-translate/useTranslation'
import {
  STATUS_CANCELLED,
  STATUS_EXPIRED,
  STATUS_UNDER_NEGOTIATION,
  STATUS_WAITING_FOR_OFFER
} from 'tennders-stracture/libs/constants'
import MarketPlaceOffers from 'tennders-market/offer/views/MarketPlaceOffers'

const TransactionSharedInMarketPlaceView = (props) => {
  const { transaction, withDocs } = props
  const [activeView, setActiveView] = useState('offers')
  const { t } = useTranslation()
  const toggleView = (view, force) => {
    if (view === activeView) {
      if (force) {
        return
      }
      setActiveView(null)
    } else {
      setActiveView(view)
    }
  }

  const docsDiv = withDocs ? (
    <>
      <li className={activeView === 'docs' ? 'active' : ''}>
        <h4 className="bold" onClick={() => toggleView('docs')}>
          {transaction?.matchedLoad ? t('transaction:shippersDocs') : t('transaction:carriersDocs')}
        </h4>
        <div
          style={activeView === 'docs' ? { display: 'block' } : { display: 'none' }}
          className="tennders-accordion-content carriers-documents-max-height tennders-custom-scroll mt-16"
        >
          {
            (transaction?.bookedBy || transaction?.status?.label === STATUS_CANCELLED || transaction?.isMarketPlaced)
          && (!transaction?.isOfferable || transaction?.status?.label !== STATUS_WAITING_FOR_OFFER)
          && (
            <DetailDocuments transaction={transaction} />
          )
          }
        </div>
      </li>
      <li>
        <DetailLog />
      </li>
    </>

  ) : null

  return (
    <>
      {(transaction?.isSharedWithMarketPlace ? (
        <ul className="tennders-accordion-list">
          <li className={activeView === 'offers' ? 'active' : ''}>
            <MarketPlaceOffers
              onToggle={(force) => toggleView('offers', force)}
              show={activeView === 'offers'}
              transaction={transaction}
            />
          </li>
        </ul>
      ) : <MarketPlaceOffers show transaction={transaction} />)}
      { transaction?.status?.label !== STATUS_WAITING_FOR_OFFER && transaction?.status?.label !== STATUS_UNDER_NEGOTIATION && transaction?.status?.label !== STATUS_EXPIRED && (
        <ul className="tennders-accordion-list">
          {docsDiv}
        </ul>
      )}
    </>
  )
}

export default React.memo(TransactionSharedInMarketPlaceView)
